<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 shadow-none">
        <div class="card-body p-3">
          <!-- Header section matches Dashboard/Employees style -->
          <div class="d-flex flex-row flex-wrap justify-content-between mb-4">
            <div>
              <h1 class="card-title mb-1">System Settings</h1>
              <span class="sub-text">Manage your profile and system-wide permissions</span>
            </div>

            <div class="d-flex gap-2 align-items-center">
              <button class="btn btn-soft-primary" (click)="openResetPasswordModal()">
                <i class="bi bi-key"></i>
                <span>Change Password</span>
              </button>
            </div>
          </div>

          <!-- Tabs - simplified and standard -->
          <ul class="nav nav-pills mb-4 gap-2 bg-light p-1 rounded-3 d-inline-flex">
            <li class="nav-item">
              <button
                class="nav-link rounded-3 px-4 py-2 border-0"
                [class.active]="activeTab === 'profile'"
                (click)="activeTab = 'profile'">
                <i class="bi bi-person-circle me-2"></i>
                Profile
              </button>
            </li>
            @if (canManagePermissions) {
              <li class="nav-item">
                <button
                  class="nav-link rounded-3 px-4 py-2 border-0"
                  [class.active]="activeTab === 'roles'"
                  (click)="activeTab = 'roles'">
                  <i class="bi bi-shield-lock-fill me-2"></i>
                  Permissions
                </button>
              </li>
            }
          </ul>

          <div class="mt-2">
            @if (isAdminDetailsLoading) {
              <app-loading-spinner></app-loading-spinner>
            } @else if (adminDetails) {
              <!-- Profile Tab -->
              @if (activeTab === 'profile') {
                <form [formGroup]="adminForm" (ngSubmit)="onSubmit()">
                  <div class="row g-4">
                    <!-- Profile Pic Column -->
                    <div class="col-lg-3 ps-0">
                      <div class="d-flex flex-column align-items-center bg-white border p-4 h-100">
                        <div class="position-relative mb-3">
                          <img
                            [src]="
                              imagePreview ||
                              profileImageUrl ||
                              getDefaultProfilePicUrl(adminDetails.first_name, adminDetails.last_name)
                            "
                            alt="{{ adminDetails.first_name }} {{ adminDetails.last_name }}"
                            class="rounded-circle border border-3 border-light shadow-sm bg-light"
                            style="width: 140px; height: 140px; object-fit: cover"
                            (error)="handleImageError($event)" />

                          <label
                            for="profileUpload"
                            class="profile-upload-btn shadow-sm position-absolute rounded-circle">
                            <i class="bi bi-camera-fill"></i>
                            <input
                              type="file"
                              id="profileUpload"
                              hidden
                              (change)="onFileSelected($event)"
                              accept="image/*" />
                          </label>
                        </div>
                        @if (imagePreview || profileImageUrl) {
                          <button
                            type="button"
                            class="btn btn-link btn-sm text-danger text-decoration-none"
                            (click)="removeProfilePicture()">
                            Remove photo
                          </button>
                        }
                        <div class="text-center mt-2">
                          <h5 class="mb-0 fw-bold">{{ adminDetails.full_name }}</h5>
                          <small class="text-uppercase text-muted letter-spacing-1" style="font-size: 10px">
                            {{ adminDetails.role || 'Member' }}
                          </small>
                        </div>
                      </div>
                    </div>

                    <!-- Form Column -->
                    <div class="col-lg-9 pe-0">
                      <div class="bg-white border p-4">
                        <h6 class="fw-bold mb-4 text-primary border-bottom pb-2">Personal Information</h6>
                        <div class="row g-3">
                          <div class="col-md-6">
                            <label class="form-label small fw-semibold">First Name</label>
                            <input
                              type="text"
                              formControlName="first_name"
                              class="form-control"
                              placeholder="First Name" />
                          </div>
                          <div class="col-md-6">
                            <label class="form-label small fw-semibold">Last Name</label>
                            <input
                              type="text"
                              formControlName="last_name"
                              class="form-control"
                              placeholder="Last Name" />
                          </div>
                          <div class="col-md-6">
                            <label class="form-label small fw-semibold">Email</label>
                            <input
                              type="email"
                              formControlName="email"
                              class="form-control"
                              placeholder="email@example.com" />
                          </div>
                          <div class="col-md-6">
                            <label class="form-label small fw-semibold">Phone</label>
                            <input
                              type="text"
                              formControlName="phone_number"
                              class="form-control"
                              placeholder="10-digit phone" />
                          </div>
                        </div>

                        <h6 class="fw-bold mb-4 mt-4 text-primary border-bottom pb-2">Location Information</h6>
                        <div class="row g-3">
                          <div class="col-12">
                            <label class="form-label small fw-semibold">Address Line 1</label>
                            <input type="text" formControlName="address_line1" class="form-control" />
                          </div>
                          <div class="col-md-6">
                            <label class="form-label small fw-semibold">City</label>
                            <input type="text" formControlName="city" class="form-control" />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label small fw-semibold">Postal Code</label>
                            <input type="text" formControlName="postal_code" class="form-control" />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label small fw-semibold">Country</label>
                            <input type="text" formControlName="country" class="form-control" />
                          </div>
                        </div>

                        <div class="text-end mt-4 pt-3">
                          <button
                            type="submit"
                            class="btn btn-primary px-4"
                            [disabled]="adminForm.invalid || isAdminDetailsSaving">
                            @if (isAdminDetailsSaving) {
                              <app-loading-spinner [inline]="true" class="me-2"></app-loading-spinner>
                            }
                            Save Settings
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              }

              <!-- Permissions Tab -->
              @if (activeTab === 'roles') {
                <app-role-management></app-role-management>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Password Modal -->
<ng-template #resetPasswordModalContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title fw-bold">Update Password</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    <app-reset-password-modal (closeModalEvent)="modal?.dismiss()"></app-reset-password-modal>
  </div>
</ng-template>
